import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { StyleValue, withDefaults } from "vue";
interface IconProps {
  color?: string;
  size?: number;
  style?: StyleValue;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    color: null,
    size: null,
    style: { default: "" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "icon",
    style: _normalizeStyle([{ color: __props.color, fontSize: __props.size + 'px' }, __props.style])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})